import { CSSProgressiveHighlightMicro } from "@caisy/league";
import styled from "styled-components";

export const SAddProjectModalSectionBreadcrumbHeader = styled.div`
  ${CSSProgressiveHighlightMicro};
  color: var(--text-03);
`;
